// extracted by mini-css-extract-plugin
export default {"container":"Rent_container__7k4S3","titulo":"Rent_titulo__LG++h"};